// ============================================================================
// ACTION TYPE ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const ACTION_TYPE_BASE_PATH = '/ActionType';

export const actionTypeEndpoints = {
  list: () => buildEndpoint(ACTION_TYPE_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${ACTION_TYPE_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${ACTION_TYPE_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(ACTION_TYPE_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${ACTION_TYPE_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${ACTION_TYPE_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${ACTION_TYPE_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default actionTypeEndpoints;
